import Add from "./Add";
import List from "./List";
import Edit from "./Edit";

const Team = {
    Add,
    List,
    Edit
};

export default Team;